module.exports = __webpack_public_path__ + "media/baojing.d3315c95.mp3";